import { Checkbox, FormControlLabel } from '@mui/material';
import React, { useState } from 'react';
import Colors from '../colors';
import CircleOutlinedIcon from '@mui/icons-material/CircleOutlined';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import ConfirmationModal from './modals/ConfirmationModal';

function CheckboxWithConfirmation({ children, label, modalText, checked, setChecked, disabled = false }) {
    const [isVisible, setIsVisible] = useState(false);

    const confirmCheckboxHandler = () => {
        setChecked(!checked);
        setIsVisible(false);
    };

    return (
        <>
            <FormControlLabel
                control={<Checkbox 
                    disabled={disabled}
                    name={label}
                    checked={checked}
                    icon={<CircleOutlinedIcon sx={{ color: Colors.red, fontSize: 30 }} />}
                    checkedIcon={<CheckCircleOutlineOutlinedIcon sx={{ backgroundColor: Colors.red, color: 'white', borderRadius: '50%', fontSize: 30 }} />}
                    onClick={() => setIsVisible(true)} />}
                label={children}
            />
            <ConfirmationModal
                isVisible={isVisible}
                setIsVisible={setIsVisible}
                mainAction={checked ? 'No' : 'Yes'}
                mainActionHandler={confirmCheckboxHandler}
                title={modalText}
                color={checked ? Colors.red : Colors.green} />
        </>
    );
}

export default CheckboxWithConfirmation;